import { eventActions } from "../../actionTypes";

const initialState = {
	categories: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case eventActions.FETCH_EVENT_CATEGORIES: {
			return { ...state, fetching: true };
		}

		case eventActions.FETCH_EVENT_CATEGORIES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				categories: action.payload.data,
			};
		}

		case eventActions.FETCH_EVENT_CATEGORIES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
